import { BrowseActionTypes } from "../models/browseActions";
import { SET_SEARCH } from "../types";

export default (search: string): BrowseActionTypes => ({
    type: SET_SEARCH,
    payload: search,
});
